module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    attrs: {
      "disabled": _vm.isDeleting
    }
  }, [(_vm.statement) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.statement.title))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n      Date: " + _vm._s(_vm.statement.date) + "\n      "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Due: " + _vm._s(_vm.statement.due_date))])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n    " + _vm._s(_vm.formatCurrency(_vm.me.profile.currency, _vm.statement.closing_balance)) + "\n    "), _c('v-list-tile-action-text', [_vm._v("\n      Balance\n    ")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "ml-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.statement.url,
      "target": "_blank",
      "icon": _vm.$vuetify.breakpoint.xs,
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("View")]), _vm._v(" "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": _vm.$vuetify.breakpoint.xs,
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("send", _vm.statement)
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Send")]), _vm._v(" "), _c('v-icon', {
    staticClass: "ml-2 visible-xs-only",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "40px"
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "icon": "",
      "color": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), (_vm.statement) ? _c('v-dialog', {
    model: {
      value: (_vm.showDeleteConfirmation),
      callback: function($$v) {
        _vm.showDeleteConfirmation = $$v
      },
      expression: "showDeleteConfirmation"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n          Are you sure you want to delete this statement?\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Permanently delete statement: "), _c('strong', [_vm._v(_vm._s(_vm.statement.title))]), _vm._v("?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.dodelete(_vm.statement.id);
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_vm._v("\n            Delete\n          ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18f6dc04","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitems/StatementListItem.vue
// module id = 1343
// module chunks = 9